module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ill"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('strong', [_vm._v("Illustrations")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "2",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#fig1"
    }
  }, [_vm._v("Abraham Gesner’s geological map of Nova Scotia (1846)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#page_16"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#fig2"
    }
  }, [_vm._v("Abraham Gesner’s geological survey of New Brunswick (1838–1842)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#page_24"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#fig3"
    }
  }, [_vm._v("Richard Taylor’s map of the coal fields of British North America (1848)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#page_36"
    }
  }, [_vm._v("36")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#fig4"
    }
  }, [_vm._v("Charles Jackson’s stratigraphy of “the regular coal series” in the region of the Albert mine")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#page_50"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#fig5"
    }
  }, [_c('em', [_vm._v("Left,")]), _vm._v(" Charles Jackson’s view of the crushed Albert “coal” on the ninth level of the Albert mine. "), _c('em', [_vm._v("Right,")]), _vm._v(" Richard Taylor and James Robb’s view of the Albert “asphaltum” as an injected vein within the crest of an anticline on the eighth level of the Albert mine.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#page_52"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#fig6"
    }
  }, [_vm._v("Richard Taylor and James Robb’s traverse section from the Albert mine, New Brunswick, to the Joggins, Nova Scotia")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#page_53"
    }
  }, [_vm._v("53")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amos Eaton’s geological nomenclature for North American rocks (1828)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")]), _vm._v("–83")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Idealized section of Paleozoic formations (circa 1860)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Lyell’s interpretation of the growth-on-the-spot theory of the origin of coal (1852)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Top,")]), _vm._v(" Charles Lyell’s ideal geological section from the Atlantic coast to the great Appalachian coal field of the Midwest. "), _c('em', [_vm._v("Bottom,")]), _vm._v(" Coal regions of Pennsylvania exhibiting Henry Darwin Rogers’s law of gradation.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Top,")]), _vm._v(" Erect "), _c('em', [_vm._v("Sigillaria")]), _vm._v(" containing the fossil reptile, "), _c('em', [_vm._v("Dendrerpeton acadianum. Bottom,")]), _vm._v(" Section of the Joggins, Nova Scotia.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Peter Lesley’s “zigzag” topography in Pennsylvania (1856)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Dwight Dana’s depiction of the Carboniferous Age (1863)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coal areas of various countries (1848)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Dwight Dana’s Geological map of the United States (1860)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bristol Mining Company stock certificate")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coal oil plant (1860)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#page_148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel M. Kier’s label for a bottle of “Petroleum”")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The oil region of Pennsylvania (1866)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Kicking Down a Well”")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Left,")]), _vm._v(" Different depths of oil wells along the Burning Spring Creek in West Virginia. "), _c('em', [_vm._v("Right,")]), _vm._v(" Vertical oil fissure.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oil well setup (1866)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Left,")]), _vm._v(" Scientific schematic of a large oil cavern (1864). "), _c('em', [_vm._v("Right,")]), _vm._v(" Popular schematic of a large oil cavern (1866).")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petroleum still and condenser")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petroleum refinery (1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hillside drilling along Pioneer Run (1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pithole (1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ideal cross section of oil wells (circa 1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#page_237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prospecting for oil")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advertisement for oil-finding engineers (1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#page_255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("255")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexander Winchell’s ideal geological section of the Neff Petroleum Company’s property in Ohio (1866)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#page_258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("258")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Various geological positions of rock oil (circa 1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#page_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("266")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. B. Andrews’s illustrations of the anticline or “break” along the Ohio River (1866)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#page_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("267")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of the Ojai rancho in Santa Barbara County and surrounding ranchos in southern California (1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#page_282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("282")]), _vm._v("–283")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentf1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Benjamin Silliman Jr.’s ideal cross section (1865)")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#page_284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("284")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cb84e60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm07_ill.vue
// module id = 78
// module chunks = 0